import { render, staticRenderFns } from "./presentationseahourse.vue?vue&type=template&id=5c14c5e4&"
import script from "./presentationseahourse.vue?vue&type=script&lang=js&"
export * from "./presentationseahourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports